import { SortDirectionSchema } from "@common/client/schemas.gen"
import { z } from "zod"
import {
  type Column,
  columnSchema,
  DEFAULT_COLUMNS,
  sortSchema,
  type ToolSort,
  withToolNumber,
} from "./columns"
import { type Grouping, groupChoiceSchema, groupingSchema } from "./grouping"
import {
  CALIBRATION_STATUSES,
  CLASSIFICATIONS,
  OWNERSHIPS,
  STATUSES,
} from "./labels"
import { TABS } from "./views"

const directionSchema = z.enum(SortDirectionSchema.enum)

export const statusSchema = z.enum(STATUSES)

export const calibrationSchema = z.enum(CALIBRATION_STATUSES)

export const classificationSchema = z.enum(CLASSIFICATIONS)

export const ownershipSchema = z.enum(OWNERSHIPS)

export const toolsSearchSchema = z.object({
  tab: z.enum(TABS).optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  status: z.array(statusSchema).optional().catch(undefined),
  calibration: z.array(calibrationSchema).optional().catch(undefined),
  category: z.array(z.string()).optional().catch(undefined),
  facility: z.array(z.string()).optional().catch(undefined),
  classification: z.array(classificationSchema).optional().catch(undefined),
  ownership: z.array(ownershipSchema).optional().catch(undefined),
  retired: z.boolean().optional().catch(undefined),
  group: groupChoiceSchema.optional().catch(undefined),
  subgroup: groupingSchema.optional().catch(undefined),
  columns: z.array(columnSchema).optional().catch(undefined),
  sort: sortSchema.optional().catch(undefined),
  direction: directionSchema.optional().catch(undefined),
})

export type ToolsSearch = z.infer<typeof toolsSearchSchema>

export type ToolsDisplay = {
  group: Grouping | undefined
  subgroup: Grouping | undefined
  columns: Column[]
  sort: ToolSort
  direction: z.infer<typeof directionSchema>
}

export function displayOf(search: ToolsSearch): ToolsDisplay {
  const group = search.group === "none" ? undefined : (search.group ?? "status")
  return {
    group,
    subgroup: group && search.subgroup !== group ? search.subgroup : undefined,
    columns: search.columns ? withToolNumber(search.columns) : DEFAULT_COLUMNS,
    sort: search.sort ?? "number",
    direction: search.direction ?? "asc",
  }
}

export function listParams(search: ToolsSearch): { include_retired: boolean } {
  return { include_retired: Boolean(search.retired) }
}
